import { TuiScrollbarModule } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'iss-drawer',
  standalone: true,
  templateUrl: './drawer.component.html',
  styleUrls: [ './drawer.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ NgIf, TuiScrollbarModule ],
})
export class DrawerComponent {
  @Input() public withHeader = true;
  @Input() public withFooter = true;
}
